<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item">
				<router-link :to="{path: '/users'}" class="text-decoration-none">Пользователи</router-link>
			</li>
			<li class="breadcrumb-item">
				<router-link :to="{path: '/users/groups'}" class="text-decoration-none">Группы пользователей</router-link>
			</li>
			<li class="breadcrumb-item active">Добавление новой группы пользователей</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<h5>Добавление новой группы пользователей</h5>
			<div class="text-muted">Создание новой группы пользователей с указанием прав доступа к проектам и причастности к пользователям</div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="init">
			<div class="spinner-border" style="width: 100px; height: 100px;"></div>
		</div>
		<form @submit.prevent="addGroup" v-else>
			<div class="row">
				<div class="col-md-5 mb-3">
					<div class="card mb-3">
						<div class="card-header">Параметры группы пользователей</div>
						<div class="card-body">
							<div>
								<label for="inputLogin" class="form-label">Название группы</label>
								<input
									ref="groupNameInput"
									class="form-control font-monospace"
									type="text"
									id="inputGroupName"
									:disabled="loading"
									v-model="group.name"
									required
								/>
							</div>
						</div>
					</div>
					<div class="card">
						<div class="card-header">Причастность к пользователям</div>
						<div class="card-body">
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="Поиск по пользователям" :disabled="loading" v-model="searchUsers" />
								<button type="button" class="btn btn-outline-secondary d-flex align-items-center px-2" :disabled="loading" @click="searchUsers = ''" v-if="searchUsers">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z" />
									</svg>
								</button>
							</div>
							<div class="form-check" v-for="user in filteredUsers" :key="user.id">
								<input class="form-check-input" type="checkbox" :value="user.id" :id="'checkUser' + user.id" :disabled="loading" v-model="group.users" />
								<label :for="'checkUser' + user.id">
									<code>{{ user.login }}</code>
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-7 mb-3">
					<div class="card">
						<div class="card-header">Права доступа к проектам</div>
						<div class="card-body">
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="Поиск по проектам" :disabled="loading" v-model="searchProjects" />
								<button type="button" class="btn btn-outline-secondary d-flex align-items-center px-2" :disabled="loading" @click="searchProjects = ''" v-if="searchProjects">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z" />
									</svg>
								</button>
							</div>
							<div class="row">
								<div class="col-md-3" v-for="project in filteredProjects" :key="project.id">
									<div class="form-check">
										<input class="form-check-input" type="checkbox" :value="project.id" :id="'checkProject' + project.id" :disabled="loading" v-model="group.projects" />
										<label class="badge text-bg-warning font-monospace" :for="'checkProject' + project.id" v-tippy="{placement: 'top', content: project.name}">{{ project.apiname }}</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<div class="d-grid gap-2 d-md-flex justify-content-md-end">
						<button
							type="submit"
							class="btn btn-primary d-flex align-items-center justify-content-center"
							:disabled="loading"
						>
							<span v-if="loading && loadingAdd" class="spinner-border spinner-border-sm me-2" role="status"></span>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
							</svg>
							<span class="ms-2">{{ loading && loadingAdd ? 'Добавление...' : 'Добавить группу пользователя' }}</span>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { useModal } from "vue-final-modal";

import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Добавление новой группы пользователей | SKV'});
	},
	data: () => ({
		init: false,
		loading: false,
		loadingAdd: false,
		users: [],
		projects: [],
		searchUsers: '',
		searchProjects: '',
		group: {
			name: '',
			users: [],
			projects: [],
		},
	}),
	computed: {
		filteredUsers(){
			const search = this.searchUsers.toLowerCase();
			return this.users.filter(user => user.login.toLowerCase().includes(search));
		},
		filteredProjects(){
			const search = this.searchProjects.toLowerCase();
			return this.projects.filter(project =>
				project.name.toLowerCase().includes(search) ||
				project.apiname.toLowerCase().includes(search)
			);
		},
	},
	methods: {
		// Загрузка начальных данных
		async loadData() {
			this.loading = true;
			try {
				// Предполагаем, что appModel доступен через this
				const [users, projects] = await Promise.all([
					this.appModel.doGetUsers({all: true}),
					this.appModel.doGetProjects({all: true}),
				]);
				this.users = users.list || [];
				this.projects = projects.list || [];
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},
		
		async addGroup() {
			this.loading = true;
			this.loadingAdd = true;
			try {
				const result = await this.appModel.doAddUserGroup(this.group);
				if (result.success) {
					useModal({
						component: BootstrapConfirmModal,
						attrs: {
							title: "Группа пользователей успешно создана!",
							centered: true,
							confirmText: "В созданную группу",
							confirmColor: "link",
							cancelText: "В список групп",
							onConfirm: () => {
								this.$router.push('/users/groups/' + result.data?.id);
							},
							onClose: () => {
								this.$router.push('/users/groups');
							},
						},
						slots: {
							default: 'Куда перейти?',
						},
					}).open();
				} else {
					this.$toast.error(result.message);
				}
			} finally {
				this.loading = false;
				this.loadingAdd = false;
			}
		},
	},
	async mounted() {
		this.init = true;
		await this.loadData();
		this.init = false;
		
		this.$nextTick(() => {
			this.$refs.groupNameInput?.focus();
		});
	},
};
</script>
